import script from "./PdfBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfBlock.vue?vue&type=script&setup=true&lang=js"

import "./PdfBlock.vue?vue&type=style&index=0&id=f3730af0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3730af0"]])

export default __exports__